module.exports = new __parcel__URL__("newEditorImage.very-specific-illu.5e606ca1.png").toString();